import { observer } from "mobx-react-lite";
import { useContext } from "react";

import {
  dataAttribute,
  DataAttributes,
  FontIcon,
  FontSizes,
  Stack,
  Text
} from "@bps/fluent-ui";
import { StatementItemsContext } from "@modules/billing/screens/statement/context/StatementItemsContext.ts";
import { ExpanderButton } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/ExpanderButton.tsx";
import { SecondColumnContent } from "@shared-types/booking/second-column-content.enum.ts";
import { useStores } from "@stores/hooks/useStores.ts";

import { StatementExpanderButtonProps } from "./StatementGenerateModal.type.ts";

export const StatementExpanderButton: React.FC<StatementExpanderButtonProps> =
  observer(props => {
    const { selectedIds, total } = useContext(StatementItemsContext);
    const { billing } = useStores();
    const { endDate, gapDays } = props;
    const openExpanderForm =
      endDate !== undefined &&
      gapDays < 121 &&
      gapDays > 0 &&
      total !== undefined &&
      total > 0;

    const showSelectNumber =
      endDate !== undefined &&
      gapDays < 121 &&
      gapDays > 0 &&
      selectedIds !== undefined &&
      selectedIds?.length > 0;
    return (
      <ExpanderButton
        {...dataAttribute(DataAttributes.Element, "statement-expander-button")}
        fields={[]}
        errorMessage=""
        onClick={() => {
          if (openExpanderForm) {
            if (
              billing.ui.statementSecondColumn !==
              SecondColumnContent.statementRun
            ) {
              billing.ui.setStatementSecondColumn(
                SecondColumnContent.statementRun
              );
            } else {
              billing.ui.setStatementSecondColumn(undefined);
            }
          } else {
            billing.ui.setStatementSecondColumn(undefined);
          }
        }}
        isOpened={
          billing.ui.statementSecondColumn === SecondColumnContent.statementRun
        }
        styles={{
          root: {
            maxWidth: "100%",
            margin: 0
          }
        }}
        disabled={!openExpanderForm}
      >
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
          <FontIcon
            iconName="Filter"
            styles={{
              root: {
                fontSize: FontSizes.size16
              }
            }}
          />
          <Text>
            Statements {showSelectNumber && `(${selectedIds?.length})`}
          </Text>
        </Stack>
      </ExpanderButton>
    );
  });
